var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"IconTextButton",class:[_vm.buttonClass, { 'outlined': _vm.outlined }],attrs:{"elevation":"0","disabled":_vm.disabled,"color":"black"},on:{"click":_vm.handleClick}},[_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.buttonText)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }